import { BuilderContentBlocks } from "../ui/BuilderContentBlocks";
import { useEffect, useState } from "react";

export default function ComponentsPage() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (!event.data) {
        return;
      }
      switch (event.data.type) {
        case "SET_CONTENT":
          const parsed = JSON.parse(event.data.message);
          setContent(parsed);
          break;
        default:
          console.log("Unknown event type received from parent.");
      }
    });
  }, []);

  if (!content.length)
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center p-5" style={{ marginTop: 110 }}>
        <p className="m-5">No components are passed in.</p>
      </div>
    );

  return (
    <div>
      <BuilderContentBlocks data={content} />
    </div>
  );
}
